import { useState } from 'react';
import { profileKey } from '../../../hooks/useAccounts';
import { STUDIO_HOME } from '../../../enums/routes';

const PANE_ID = 'studio-profile-pane';
const tabId = profile => `studio-profile-tab-${profileKey(profile).replace(/[^a-z0-9_-]/gi, '-')}`;

// Which of the creator's profiles the dialog shows: the one in use when it opens, then
// the creator's pick. Showing one never switches the Studio to it; `use` does.
export default function useProfileManager(s) {
  const { accounts, features, capabilities } = s;
  const [choice, setChoice] = useState(() => (accounts.active ? profileKey(accounts.active) : null));
  const selected = accounts.list.find(profile => profileKey(profile) === choice) || accounts.active;
  const multiple = !!features.multiple_profiles;
  return {
    // Signed in with a connected profile; a visitor only drafts.
    enabled: !!s.auth.signed && !!selected,
    selected,
    selectedKey: selected ? profileKey(selected) : null,
    inUse: !!selected && !!accounts.active && profileKey(selected) === profileKey(accounts.active),
    multiple,
    canAdd: accounts.canAdd,
    max: multiple ? capabilities?.limits?.max_profiles ?? null : null,
    paneId: PANE_ID,
    tabId,
    choose: profile => setChoice(profileKey(profile)),
    use: () => accounts.select(selected),
    // The same @ onboarding as the first profile, on the home.
    connect: () => { s.setModal(null); s.onboarding.startAdding(); s.navigate(STUDIO_HOME); },
  };
}
